if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
        this.bindBetiesReading();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * beties v9.9 (nur Handy): Leiste mit „×“ schließbar (gilt für den Besuch)
     * und ausgeblendet, solange Beschreibung/Reiter oder ein geöffneter Infobereich im Bild sind.
     */
    bindBetiesReading() {
      const key = 'betiesStickyAtcClosed';
      let closed = false;
      try { closed = window.sessionStorage.getItem(key) === '1'; } catch (e) { closed = false; }
      if (closed) this.classList.add('sticky-atc-panel--closed');

      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'sticky-atc-panel__close';
      close.setAttribute('aria-label', 'Leiste schließen');
      close.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>';
      close.addEventListener('click', () => {
        this.classList.add('sticky-atc-panel--closed');
        try { window.sessionStorage.setItem(key, '1'); } catch (e) { /* ohne Speicher nur für diese Seite */ }
      });
      this.append(close);

      const visible = new Set();
      const update = () => {
        if (theme.mediaMatches.md) { this.classList.remove('sticky-atc-panel--reading'); return; }
        const reading = Array.from(visible).some((el) => el.tagName !== 'DETAILS' || el.open);
        this.classList.toggle('sticky-atc-panel--reading', reading);
      };
      const readingObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
        });
        update();
      }, { rootMargin: '0px 0px -30% 0px' });

      document.querySelectorAll('.cc-product-details').forEach((el) => readingObserver.observe(el));
      if (this.productInfo) {
        this.productInfo.querySelectorAll('details').forEach((el) => {
          readingObserver.observe(el);
          el.addEventListener('toggle', update);
        });
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
